import React from "react";
import history from "../../utilities/history";
import backArrow from "../../images/back-arrow.svg";

const Backbutton = () => {
  const onHandleClick = () => {
    history.goBack();
  };
  return (
          <img
            tabIndex="-1"
            onClick={onHandleClick}
            className="btn btn-back float-right"
            src={backArrow}
            alt="back-arrow"
          />
    
  );
};
export default Backbutton;
